import React, { FC } from 'react';

import { Button2, DialogModal, DialogModalProps } from 'Modules/ui3';
import { useTranslation } from 'Modules/core/i18n';
import { useAction } from 'Modules/core/redux';

import { messagingActions } from '../../state/actions';
import { modalClassNames, useModalContext } from '../Modal';
import { ModalComponentProps } from '../Modal/types';


export type ErrorModalProps = Pick<DialogModalProps, 'title' | 'text'>;

const ErrorModalComponent: FC<ErrorModalProps> = props => {
    const { t } = useTranslation('errorModal');
    const { modal } = useModalContext();
    const close = useAction(() => messagingActions.hideMessage(modal.id), [modal.id]);
    return (
        <DialogModal {...props}>
            <Button2 variantType='brand' onClick={close} data-testid='button-close'>
                {t('close')}
            </Button2>
        </DialogModal>
    );
};

export const ErrorModal: ModalComponentProps = {
    component: ErrorModalComponent,
    containerClass: modalClassNames.contentDfa,
    closeButtonVariant: 'dfaSmall',
};
